import { take, put, fork, call } from "redux-saga/effects"
import { authRequest } from "src/engine/modules/authRequest"
import env from "src/env"
import { REQUEST_STATUS_TRANSITION_LIST } from "../actions/types"

import {
  requestTransitionListSuccess,
  requestTransitionListError,
} from "../actions/creators"

const { REACT_APP_API_URL } = env

function* request(action) {
  const { event } = action.config
  try {
    const response = yield call(authRequest, {
      url: `${REACT_APP_API_URL}/events/${event}/transitions`,
    })

    yield put(requestTransitionListSuccess(response))
  } catch (error) {
    yield put(requestTransitionListError(error))
  }
}

export default function* transitionSaga() {
  while (true) {
    const action = yield take(REQUEST_STATUS_TRANSITION_LIST)
    yield fork(request, action)
  }
}
